export const createCampaignSlice = (set) => ({
  workflowMode: "static",
  setWorkflowMode: (mode) => set({ workflowMode: mode }),
  selectedContacts: [],
  setSelectedContacts: (contacts) => set({ selectedContacts: contacts }),
  clearSelectedContacts: () => set({ selectedContacts: [] }),
  contactsToAddToCampaign: [],
  setContactsToAddToCampaign: (contacts) =>
    set({ contactsToAddToCampaign: contacts }),
  clearContactsToAddToCampaign: () => set({ contactsToAddToCampaign: [] }),
  // Persists across tab switches so the generate button stays in loading state
  isGeneratingCampaignContent: false,
  setIsGeneratingCampaignContent: (val) =>
    set({ isGeneratingCampaignContent: val }),
});